jQuery(document).ready(function () {
    readMore();
    scrollTop();
    toggleBlockManualInternalLinking();
    toggleSearchform();
    wpmlLanguageSelectorRGAA();
    clickNavigationLinkWithoutHref();
    faq_yoast();

    gsap.config({
        nullTargetWarn: false,
    });

    // Slider
    if (jQuery('.pgut-slider').length > 0) {
        jQuery('.pgut-slider .pgut-arrow').click(function () {
            scrollingLeft(jQuery(this));
        });
    }

    jQuery("a[target=_blank]").each(function () {
        if (jQuery(this).attr('aria-label')) {
            let currentLabel = jQuery(this).attr('aria-label');
            jQuery(this).attr('aria-label', currentLabel + " - Ouvre dans un nouvel onglet");
        } else {
            jQuery(this).attr('aria-label', "Ouvrir dans un nouvel onglet");
        }
    });

    jQuery('.powergut-slider__slick').slick({
        "slidesToShow": 10,
        "slidesToScroll": 1,
        "dots": false,
        "responsive": [
            {
                "breakpoint":1439,
                "settings":{
                    slidesToShow: 4
                }
            },
            {
                "breakpoint":767,
                "settings":{
                    slidesToShow: 2
                }
            },
        ]
    });
});

var counter_effect = false;
jQuery(window).scroll(function(){
    // Activer l'effet Compteur quand on arrive dessus
    if(jQuery('.pgut-counter__number').length > 0){
        var top_window = jQuery('.pgut-counter__number').offset().top - window.innerHeight;
        if(!counter_effect && jQuery(window).scrollTop() > top_window){
            counterEffect();
            counter_effect = true;
        }
    }
});


// Animation de compteur de chiffres
function counterEffect() {
    jQuery('.pgut-counter__number').each(function () {
        var $this = jQuery(this);
        var split_string = $this.text().split(",");
        // Pour les nombres à décimales
        // On coupe la chaine en 2 et on fait deux compteurs différents
        if(split_string.length > 1){
            $this.html("<span class='pgut-counter__number-part'>"+split_string[0]+"</span>,<span class='pgut-counter__number-part'>"+split_string[1]+"</span>");
            jQuery.each(split_string, function(i, $val){;
                $val = $this.find('.pgut-counter__number-part').eq(i).text();
                jQuery({ Counter: 0 }).animate({ Counter: $this.find('.pgut-counter__number-part').eq(i).text() }, {
                    duration: 1000,
                    easing: 'swing',
                    step: function (now) {
                        $this.find('.pgut-counter__number-part').eq(i).text(Math.ceil(now).toLocaleString('fr'));
                    }
                });
            });
        }
        else {
            jQuery({ Counter: 0 }).animate({ Counter: $this.text() }, {
                duration: 1000,
                easing: 'swing',
                step: function (now) {
                    $this.text(Math.ceil(now).toLocaleString('fr'));
                }
            });
        }



    });
}

function initSortByPosts(){
    if(jQuery('#pgut-sort-by').length > 0){
        jQuery('#pgut-sort-by').on('change', function(){
            var sortValue = jQuery(this).val();
            var currentUrl = new URL(window.location.href);
            var params = new URLSearchParams(currentUrl.search);

            // Update the sort_by parameter
            params.set('sort_by', sortValue);

            // Reload the page with the updated query parameters
            window.location.href = currentUrl.pathname + '?' + params.toString();
        });
    }
}

function readMore(action = 'hide'){
    let elements =  jQuery('.js-read-more');

    if (action === 'hide') {
        elements.each(function () {
            let parent = jQuery(this);
            let read_content = parent.nextAll().detach();
            let content_block = jQuery(this).closest('.wp-block-group').find('.js-read-more-content').appendTo(parent.parent());
            read_content.appendTo(content_block);
        });
    }

    elements.click(function (e) {
        e.preventDefault();

        let tl = gsap.timeline();
        tl.to(jQuery(this), {ease: 'power0', opacity: 0, overflow: 'hidden', display: 'none'});
        tl.to(jQuery(this).parent().next(), {
            ease: 'power0', opacity: 1, height: 'auto', onComplete: function () {
                ScrollTrigger.refresh();
            }
        });
    });
}
function toggleBlockManualInternalLinking(){
    // Block Internal Linking - Ouvrir / Fermer les accordéons
    if(jQuery('.pgut-manual-internal-linking').length > 0){
        jQuery('.pgut-manual-internal-linking .pgut-manual-internal-linking__heading').click(function(){
            jQuery(this).parent().toggleClass('open');
        });
    }
}

function toggleSearchform(){
    if(jQuery('.pgut-search').length > 0) {
        jQuery('.pgut-search__content').on('click keypress', function () {
            jQuery(this).parent().toggleClass('pgut-search__open');

            if(jQuery(this).parent().hasClass('pgut-search__open')){
                jQuery('#pgut-searchform > input[type="text"]').focus();
            }
        });

        jQuery('.pgut-search__content__opened .pgut-icon').on('click keypress', function () {
            jQuery(this).closest('.pgut-search').toggleClass('pgut-search__open');
        });
    }
}

// Scroll to left or right inside an element
    function scrollingLeft(element_arrow) {
        var width_scroll = element_arrow.closest('.pgut-slider').find('.pgut-slide').width()+18;
        var scroll_left = 0;
        if(element_arrow.hasClass('pgut-arrow-left')){
            scroll_left = "-="+width_scroll+"px";
        }
        else {
            scroll_left = "+="+width_scroll+"px";
        }
        element_arrow.closest('.pgut-slider').find('.pgut-slider__container').animate({
            scrollLeft: scroll_left
        }, "slow");
    }

function wpmlLanguageSelectorRGAA(){
    // Sélectionner le bouton qui déclenche l'ouverture du sélecteur
    var dropdownToggle = document.querySelector('.wpml-ls-dropdown .wp-block-navigation-item__content');

    if (dropdownToggle) {
        // Rendre l'élément focusable
        dropdownToggle.setAttribute('tabindex', '0');

        // Écouter l'événement clavier (keydown)
        dropdownToggle.addEventListener('keydown', function(event) {
            // Vérifier si la touche est "Entrée" ou "Espace"
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault(); // Empêche un défilement involontaire par la touche Espace
                // Simuler le clic qui déclenche l'ouverture/fermeture du dropdown
                dropdownToggle.click();
            }
        });
    }
}

function clickNavigationLinkWithoutHref(){
    if(jQuery('header .wp-block-navigation__responsive-container-content .wp-block-navigation-item > a[href="#"]').length > 0){
        jQuery('header .wp-block-navigation__responsive-container-content .wp-block-navigation-item > a[href="#"]').click(function(e){
            e.preventDefault();
            var $button_to_submenu = jQuery(this).parent().find('button');
            if($button_to_submenu.attr('aria-expanded') === "false"){
                $button_to_submenu.attr('aria-expanded', true);
            }
            else {
                $button_to_submenu.attr('aria-expanded', false);
            }
        });
    }
}

function scrollTop(){
    jQuery('.pgut-scroll-top').click(function(){
        jQuery('html, body').animate({scrollTop: '0px'}, 500);
    });
}

function faq_yoast(){
    let $faq = jQuery('.wp-block-yoast-faq-block');

    if($faq.length) {
        $faq.each(function() {
            let $this = jQuery(this);
            let $faq_section = $this.find('.schema-faq-section');
            $faq_section.each(function() {
                let $this = jQuery(this);
                $this.attr('tabindex', '0');
                let $question = $this.find('.schema-faq-question');
                let $answer = $this.find('.schema-faq-answer');

                $question
                    .addClass('js-active')
                    .addClass('js-closed');

                $this
                    .on('focus', function () {
                        $answer.slideDown();
                        $question.removeClass('js-closed');
                    })
                    .on('focusout ', function () {
                        $answer.slideUp();
                        $question.addClass('js-closed');
                    })

            })
        })
    }
}